import "./register.scss";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import apiRequest from "../../../lib/apiRequest";
import { AuthContext } from "../../../context/AuthContext";
import { useContext, useEffect } from "react";
import bg from "../../../assets/bg.png";
import { isLocalhost } from "../../../../checkLocalhost";

import { useApiError } from "../../../lib/errorHandler";
import { useToast } from "../../../components/showtoast/ToastContext";


function Register() {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { updateUser } = useContext(AuthContext);

  const handleApiError=useApiError();
  const { showToast } = useToast(); // <-- get it from context

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(''); 

    const formData = new FormData(e.target);
    const username = formData.get("username");
    const email = formData.get("email");
    const password = formData.get("password");


// Client-side validation
  const validationError = validateForm({ username, email, password });
  if (validationError) {
    setError(validationError);
    handleApiError({ message: validationError }); // show toast    
    setIsLoading(false);
    return; // stop execution
  }

    try {
      const res = await apiRequest.post("/auth/register", { username, email, password });
      console.log("showToast called", res);

      showToast("Registration successful! Please login.", "success");

      navigate("/login");
    } catch (err) {
 
      console.log(err);
      const message = handleApiError(err?.response?.data); // shows toast
      setError(err?.response?.data?.message);


    } finally {
      setIsLoading(false);
    }
  };




const validateForm = ({ username, email, password }) => {
  if (!username || username.length < 3) {
    return "Username must be at least 3 characters long.";
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email || !emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  if (!password || password.length < 8) {
    return "Password must be at least 8 characters long.";
  }
  return null; // no errors
};




  const generatePassword = () => {
    const length = 8; // Password length
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';
    const specialChars = '!@#$%^&*()_+[]{}|;:,.<>?';
  
    let password = '';
  
    // Ensure at least 1 uppercase letter, 1 special character, and 2 digits are included
    password += uppercase[Math.floor(Math.random() * uppercase.length)];  // 1 uppercase
    password += specialChars[Math.floor(Math.random() * specialChars.length)];  // 1 special character
    password += digits[Math.floor(Math.random() * digits.length)];  // 1 numeric digit
    password += digits[Math.floor(Math.random() * digits.length)];  // 2nd numeric digit
  
    // Add 4 more random lowercase characters (to make up the 8 total characters)
    for (let i = password.length; i < length - 2; i++) {
      password += lowercase[Math.floor(Math.random() * lowercase.length)];
    }
  
    // Shuffle the password to mix the order of characters
    password = password.split('').sort(() => Math.random() - 0.5).join('');
  
    return password;
  };

  const handleLogout = () => {
    // fetch("http://localhost:8800/api/passport/logout", {

  // const SERVER_DBASEURL=  import.meta.env.VITE_IS_LOCALHOST=='true'
  const SERVER_DBASEURL=  isLocalhost
  ?import.meta.env.VITE_DSERVER_BASEURL+import.meta.env.VITE_API
  :import.meta.env.VITE_SH_DSERVER_BASEURL+import.meta.env.VITE_SH_API



    fetch(SERVER_DBASEURL+"/passport/logout", {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((response) => {
        if (response.ok) {
          // console.log("Client: User logged out");
          // navigate("/");
        } else {
          // console.error("Logout failed:", response.statusText);
        }
      })
      .catch((err) => {
        // console.error("Logout failed:", err);
      });
  };

  // const handleGoogle = () => {
  //   const authWindow = window.open("http://localhost:8800/api/passport/google", "_blank", "width=500,height=600");

  //   const handleMessage = (event) => {
  //     if (event.origin === "http://localhost:8800" && event.data.user) {
  //       // console.log("Received user data:", event.data.user);
  //       const newUser = {
  //         username: event.data.user.displayName,
  //         email: event.data.user.emails[0].value,
  //         avatar: event.data.user.photos[0].value
  //       };
        
  //       // console.log(newUser);
  //       // insert user {username: email, email: email, password: generatePassword()}
        
  //       // updateUser(event.data.user);
  //       // authWindow.close();
  //       window.removeEventListener("message", handleMessage);
  //       // navigate("/");
  //     } else {
  //       console.log("Received message from unknown origin or without user data:", event);
  //     }
  //   };

  //   window.addEventListener("message", handleMessage);

  //   // Clean up the event listener when the component unmounts
  //   const cleanup = () => {
  //     window.removeEventListener("message", handleMessage);
  //     if (authWindow) {
  //       authWindow.close();
  //     }
  //   };

  //   window.addEventListener("beforeunload", cleanup);
  //   return cleanup;
  // };

  // useEffect(() => {
  //   // Test CORS with a simple fetch request
  //   fetch("http://localhost:8800/api/test", {
  //     method: "GET",
  //     credentials: "include",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Accept": "application/json"
  //     }
  //   })
  //     .then(response => response.json())
  //     .then(data => console.log("CORS test response:", data))
  //     .catch(err => console.error("CORS test failed:", err));
  // }, []);

  return (
    <div className="register">
      <div className="wrapper">
        <div className="loginTitle PageHeader">
          <h1>Registration</h1>
        </div>
        <div className="myRow">
          {/* <div className="left">
            <div className="loginButton google" onClick={handleGoogle}>
              <img src="google.png" alt="" className="icon" />Google
            </div>
            <div className="loginButton facebook">
              <img src="facebook.png" alt="" className="icon" />Facebook
            </div>
            <div className="loginButton instagram">
              <img src="insta.png" alt="" className="icon" />Instagram
            </div>

            <div className="loginButton logout" onClick={handleLogout}>
              <img src="logout.png" alt="" className="icon" />logout
            </div>
          </div>
           */}
          <div className="inputContainer">
            <div className="formContainer">
              <form onSubmit={handleSubmit}>
                <input name="username" type="text" placeholder="Username" />
                <input name="email" type="text" placeholder="Email" />
                <input name="password" type="password" placeholder="Password" />
                <button disabled={isLoading}>Register</button>
                {error && <span>{error}</span>}
                <Link to="/login">Do you have an account?</Link>
              </form>
            </div>
          </div>
          <div className="imgContainer">
            <img src={bg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
